<template>
    <div>
        <div class="header-return">
            <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
                <el-form-item>
                    <el-select v-model="formInline.itemId"  filterable
                                remote
                                clearable
                                reserve-keyword
                                placeholder="输入名称查询"
                               @change="itemChange"
                                :remote-method="querySearch">
                        <el-option v-for="item in productList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="getList">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-table :data="list" stripe border center :size="GCONFIG.styleTableSize">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column label="标识" prop="mediaId" width="80"></el-table-column>
            <el-table-column label="名称" prop="itemName" width="190"></el-table-column>
            <el-table-column label="类型" prop="typeName" width="150"></el-table-column>
            <el-table-column label="创建人" prop="creator" width="230"></el-table-column>
            <el-table-column label="创建时间" prop="createTime"></el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button-group>
                        <!--<el-button type="success" size="mini" @click="edit(scope.row)">编辑</el-button>-->
                        <el-button type="danger" size="mini" @click="handleDel(scope.row)">删除</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="recordsTotal">
            </el-pagination>
        </div>

    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getMiniMediaManaDataList, deleteQiWeiMedia,getItemList
    } from '../../api/api';
    import {getRouterPageHash} from '@/api/http';
    export default {
        data() {
            return {
                list: [],
                productList:[],
                recordsTotal: 0,
                queryForm:{
                    currentPage: 1,
                    pageSize: 20,
                    name:''
                },
                formInline: {
                    currentPage: 1,
                    pageSize: 20,
                    itemId:''
                },
                loading: true,
            }
        },
        created() {

        },
        //挂载时候执行
        mounted(){
            this.getList();
            this.querySearch('');
        },
        methods: {
            getList(){
                //查询模板列表
                getMiniMediaManaDataList(this.formInline).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.recordsTotal = res.data.value.total;
                        this.list = res.data.value.list;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            querySearch(name){
                this.queryForm.name = name;
                this.productList = [];
                getItemList(this.queryForm).then((res) => {
                    console.log(res.data.value.list)
                    this.productList = res.data.value.list;
                })
            },
            itemChange(itemId){
                this.formInline.itemId=itemId
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleDel(row){
                //删除
                this.$confirm('删除不可撤销, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteQiWeiMedia({mediaId: row.mediaId}).then((res) => {
                        console.log(res);
                        if (res.data.success) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList();
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                })
            },
            returnHistory(){
                window.history.back()
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/distribution/siYuLink.vue